import { createAction } from '@ngrx/store';

export enum AppConfigActionTypes {
	ClearConfig = '[App config Effects] Clear',
}

/**
 * Clears all configs
 */
export const clearApplicationConfigAction = createAction('[App config Effects] Clear');
